<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="512px"
    height="512px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 512 512"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <!-- <defs>
      <style type="text/css">
        <![CDATA[
         .fil0 {fill:#1A1A1A}
        ]]>
      </style>
    </defs> -->
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_2757912204048">
        <path
          class="fil0"
          d="M221.76 365.51c4.88,24.07 35.18,38.04 56.42,19.98 9.69,-8.23 12.7,-17.07 12.67,-33.85l-0.01 -138.98c0,-29.91 -1.54,-64.15 0.16,-93.52l15.27 14.94c6.19,6.83 42.35,43.06 48.17,46.4 33.72,19.36 70.9,-23.98 42.02,-55.01 -16.74,-17.98 -43.85,-43.72 -63.02,-63.03 -10.39,-10.47 -21.1,-21.06 -31.51,-31.52l-23.78 -23.49c-2.47,-2.08 -7.64,-4.54 -9.26,-5.86 -28.02,-4.59 -30.86,0.85 -46.57,16.79 -10.82,10.99 -21.56,21.87 -33.36,33.35l-33.33 33.38c-4.96,5.22 -11.42,11.73 -16.58,16.82 -8.59,8.48 -27.02,25.07 -31.09,34.7 -11.89,28.15 16.53,56.83 43.62,46.39 12.59,-4.86 24.53,-20.18 35.9,-30.88 3.12,-2.94 4.96,-5.02 8.39,-8.28 1.71,-1.62 2.29,-2.68 3.99,-4.32l20.91 -19.75c1.32,40.38 0.21,82.86 0.2,123.47 -0.01,22.19 -0.91,106.82 0.79,122.27z"
        />
        <rect
          class="fil0"
          x="459.85"
          y="292.82"
          width="52.15"
          height="218.87"
          rx="26.08"
          ry="31.8"
        />
        <rect
          class="fil0"
          x="441.75"
          y="204.43"
          width="70.25"
          height="307.57"
          rx="35.12"
          ry="44.69"
        />
        <rect
          class="fil0"
          transform="matrix(1.76246E-14 -0.399767 0.847189 1.34788E-14 0.000462246 511.726)"
          width="175.62"
          height="604.35"
          rx="87.81"
          ry="87.81"
        />
        <rect
          class="fil0"
          y="328.84"
          width="70.25"
          height="183.16"
          rx="35.12"
          ry="26.61"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
